import { AppSettings } from "@/AppSettings";
import { NoteStatus } from "@/api/dtos";
import { StatusListItemTooltip } from "@/components/lists/status/StatusListStats";
import ParticipantNotesAndQueriesContext from "@/contexts/data/ParticipantNotesAndQueriesContext";
import useItem from "@/hooks/form/source-data/useItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LoadingButton } from "@mui/lab";
import { Box, Divider, Tooltip, TooltipProps, alpha, styled, tooltipClasses } from "@mui/material";
import { FC, useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import { ButtonPlaceholder, CounterButton, CounterButtonBox, CounterChip, StyledTooltip } from ".";

const SourceDataFormNoteButton: FC<{ itemData?: ReturnType<typeof useItem>; createButtonProps: (link: string) => any}> = ({
    itemData,
    createButtonProps
}) => {
    const { itemMap, loading, validating } = useContext(ParticipantNotesAndQueriesContext);

    const notesAndQueries = useMemo(() => {
        if (
            !itemData?.studyEventOid || 
            !itemData?.studyEventRepeat || 
            !itemData?.caseReportFormOid || 
            !itemData?.itemGroupRepeat || 
            !itemData?.itemName
        ) {
            return {
                list: undefined,
                openCount: 0
            };
        }

        const list = itemMap?.[itemData.studyEventOid]?.[itemData.studyEventRepeat]?.[itemData.caseReportFormOid!]?.[itemData.itemGroupName ?? AppSettings.metadata.itemGroupUngroupedKey]?.[itemData.itemGroupRepeat!]?.[itemData.itemName];

        return {
            list,
            openCount: list?.reduce<number>((count, current) => {
                if (current.status === NoteStatus.New || current.status === NoteStatus.Updated || current.status === NoteStatus.ResolutionProposed) {
                    return count + 1;
                }

                return count;
            }, 0) ?? 0
        }
    }, [ itemMap, itemData?.studyEventOid, itemData?.studyEventRepeat, itemData?.caseReportFormOid, itemData?.itemGroupName, itemData?.itemGroupRepeat, itemData?.itemName ]);

    if (!itemData?.configuration?.allowNotes) {
        return <ButtonPlaceholder />;
    }

    const disabled = !itemData.sourceDataItem;

    let buttonProps: any = createButtonProps(itemData?.preview ? itemData.previewNoteLink : itemData?.dataNoteLink!);

    return (
        <Box>
            <StyledTooltip
                title={
                    disabled ? 
                        'Entry missing from OpenClinica':
                        'Notes & Queries'
                }
                followCursor
            >
                <CounterButtonBox>
                    <CounterButton
                        variant="outlined"
                        //@ts-ignore
                        {...buttonProps}
                        loading={loading}
                        disabled={disabled}
                    >
                        {!!notesAndQueries.list?.length && <CounterChip>{notesAndQueries.openCount > 0 ? notesAndQueries.openCount : null}</CounterChip>}
                        <FontAwesomeIcon icon={AppSettings.icons.note} size="2x" />
                    </CounterButton>
                </CounterButtonBox>
            </StyledTooltip>
        </Box>
    );
};

export default SourceDataFormNoteButton;